import { render, staticRenderFns } from "./DeviceSwitchDisabled.vue?vue&type=template&id=06345180&"
import script from "./DeviceSwitchDisabled.vue?vue&type=script&lang=js&"
export * from "./DeviceSwitchDisabled.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSwitchDisabled.vue?vue&type=style&index=0&id=06345180&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports